/*
 * Caramel 2026-07-24
 * Lazy-loads background .mp4 videos used by promo-grid "advanced" blocks
 * (e.g. Shop by Level on the home page). See snippets/video-div.liquid:
 * the <video> tag is rendered with preload="none" and data-src (instead of
 * src) so the browser does NOT start downloading the file on page load.
 * This watches for .lazy-video elements and only sets .src / calls
 * .play() once the block is about to enter the viewport, so the video's
 * weight is only paid for by visitors who actually scroll to it.
 *
 * ----------------------------------------------------------------------
 * Caramel PERF 2026-08-06 - DOS ANADIDOS
 * ----------------------------------------------------------------------
 *
 * 1) RESOLUCION REDUCIDA EN CONEXIONES MALAS.
 *    sections/caramel-video-banner.liquid pinta ahora, ademas de data-src
 *    (la version normal, 720p por defecto), un data-src-small con la
 *    rendicion mas ligera que tenga el video (480p o menos). Aqui se
 *    elige una u otra ANTES de descargar nada:
 *      - saveData activado (el visitante ha pedido expresamente ahorrar
 *        datos en su navegador) -> no se carga NINGUN video, se queda el
 *        poster. Descargarle 2 MB de fondo decorativo a quien acaba de
 *        pedir lo contrario es pasarse.
 *      - effectiveType 2g / slow-2g -> tampoco. A esa velocidad el video
 *        llegaria despues de que la persona se haya ido.
 *      - effectiveType 3g -> se usa data-src-small si existe.
 *      - resto (4g o navegador sin Network Information API, p.ej. Safari)
 *        -> data-src normal.
 *
 *    NO subir el umbral a "cargar siempre": el banner es decorativo, va
 *    en bucle y no comunica nada que el poster no comunique ya. Es el
 *    primer candidato a sacrificar cuando la conexion es mala.
 *
 * 2) PAUSA FUERA DE PANTALLA. Antes, una vez cargado, el video seguia
 *    reproduciendose en bucle aunque estuviera fuera del viewport,
 *    gastando CPU y bateria en un elemento que nadie ve. Ahora el mismo
 *    IntersectionObserver lo pausa al salir y lo reanuda al volver a
 *    entrar (por eso ya no se hace unobserve tras la primera carga).
 */
(function () {
  function initCaramelLazyVideos() {
    var videos = document.querySelectorAll('video.lazy-video[data-src]');
    if (!videos.length) return;

    /* Devuelve la URL a cargar, o null si en esta conexion no se debe
       cargar video ninguno. */
    function pickSource(video) {
      var normal = video.dataset.src;
      var small = video.dataset.srcSmall || normal;
      var conn =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

      if (!conn) return normal;
      if (conn.saveData) return null;

      var type = conn.effectiveType || '';
      if (type === '2g' || type === 'slow-2g') return null;
      if (type === '3g') return small;

      return normal;
    }

    function loadAndPlay(video) {
      if (!video.getAttribute('src')) {
        var src = pickSource(video);
        /* null = conexion lenta o ahorro de datos: se deja el poster y se
           marca para no volver a intentarlo en cada scroll. */
        if (!src) {
          video.dataset.crmlSkipped = 'true';
          return;
        }
        video.src = src;
        video.load();
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay can be blocked in some contexts even when muted
             (e.g. reduced-data mode); failing silently just leaves the
             poster image showing, which is an acceptable fallback. */
        });
      }
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadAndPlay);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (video.dataset.crmlSkipped === 'true') return;

          if (entry.isIntersecting) {
            loadAndPlay(video);
          } else if (video.getAttribute('src') && !video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCaramelLazyVideos);
  } else {
    initCaramelLazyVideos();
  }
})();
